export default "__VITE_ASSET__M_h6ZOS8__"